// extracted by mini-css-extract-plugin
export default {"menu-item":"B7qq2_y2SWpemwVccM9E","add-btn":"L980hR_dEWwrDlUuGWWH"};